class TotpRequiredError extends Error {
  constructor(msg) {
    super(msg);
    this.message = 'Totp Required';
  }
}

export default TotpRequiredError;
